var _excluded = ["as"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled from 'styled-components';
var StyledSvg = /*#__PURE__*/styled.svg.withConfig({
  displayName: "Icon__StyledSvg",
  componentId: "h05uva-0"
})(["fill:", ";color:", ";height:", ";width:", ";", ";"], function (props) {
  return props.color;
}, function (props) {
  return props.color;
}, function (props) {
  return props.size === 'auto' ? 'auto' : props.theme.sizes[props.size];
}, function (props) {
  return props.size === 'auto' ? '100%' : props.theme.sizes[props.size];
}, function (props) {
  return props.rotateIcon !== undefined && "transform: rotate(".concat(props.rotateIcon, "deg);");
});
var Icon = function Icon(_ref) {
  var as = _ref.as,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledSvg, _extends({
    as: as,
    size: other.size || 'sz32',
    strokeWidth: other.strokeWidth || 0
  }, typeof other.rotateIcon === 'number' ? {
    rotateIcon: other.rotateIcon
  } : {}, other));
};
export default Icon;